import Home from "./components/Home";
import Navbar from "./components/Navbar";
import SocialLinks from "./components/SocialLinks";
import About from "./components/About";
import Portofolio from "./components/Portofolio";
import Experience from "./components/Experience";
import Contact from "./components/Contact";


function App() {
  return (
   <div>
    <Navbar/>
    <Home/>
    <SocialLinks/>
    <About/>
    <Portofolio/>
    <Experience/>
    <Contact/>
   </div>
    
  );
}

export default App;
